type UploadSession = {
  accessToken: string;
  folderId: string;
  expiresAt: number;
};

export async function uploadPdfToDrive(
  file: File,
  session: UploadSession,
  onProgress?: (pct: number) => void
): Promise<{ fileId: string }> {
  if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
    throw new Error('Yalnızca PDF dosyaları yüklenebilir.');
  }

  const metadata = {
    name: file.name,
    mimeType: 'application/pdf',
    parents: [session.folderId],
  };

  const initRes = await fetch('https://www.googleapis.com/upload/drive/v3/files?uploadType=resumable', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${session.accessToken}`,
      'Content-Type': 'application/json; charset=UTF-8',
      'X-Upload-Content-Type': 'application/pdf',
      'X-Upload-Content-Length': String(file.size),
    },
    body: JSON.stringify(metadata),
  });

  if (!initRes.ok) {
    const errText = await initRes.text();
    throw new Error(`Drive yükleme başlatılamadı: ${errText.slice(0, 120)}`);
  }

  const uploadUrl = initRes.headers.get('Location');
  if (!uploadUrl) {
    throw new Error('Drive upload URL alınamadı');
  }

  const CHUNK = 256 * 1024;
  let offset = 0;

  while (offset < file.size) {
    const end = Math.min(offset + CHUNK, file.size);
    const chunk = file.slice(offset, end);
    const res = await fetch(uploadUrl, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${session.accessToken}`,
        'Content-Length': String(end - offset),
        'Content-Range': `bytes ${offset}-${end - 1}/${file.size}`,
      },
      body: chunk,
    });

    if (res.status === 308) {
      offset = end;
      onProgress?.(Math.round((offset / file.size) * 100));
      continue;
    }

    if (!res.ok) {
      const errText = await res.text();
      throw new Error(`Drive yükleme hatası: ${errText.slice(0, 120)}`);
    }

    const data = await res.json();
    onProgress?.(100);
    return { fileId: data.id };
  }

  throw new Error('Drive yükleme tamamlanamadı');
}
